import script from "./VehicleItem.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleItem.vue?vue&type=script&setup=true&lang=js"

import "./VehicleItem.vue?vue&type=style&index=0&id=5dd0e829&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dd0e829"]])

export default __exports__